import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { HomeComponent } from "../home/home.component";
import { AuthGuardService } from "../../shared/services/auth-guard.service";
import { recursosHumanosRoute } from "../../recursos-humanos/shared/data.service";
import { RecursosHumanosComponent } from "../../recursos-humanos/recursos-humanos.component";
import { PessoasComponent } from "../../recursos-humanos/pessoas/pessoas.component";
import { pessoasRoute } from "../../recursos-humanos/pessoas/shared/data.service";
import { pessoasRoutes} from "../../recursos-humanos/pessoas/pessoas-routing.module";
import { motoristasRoute } from "../../recursos-humanos/motoristas/shared/data.service";
import { motoristasRoutes } from "../../recursos-humanos/motoristas/motoristas-routing.module";
import { MotoristasComponent } from "../../recursos-humanos/motoristas/motoristas.component";
import { estruturasRoute } from "../../estruturas/shared/data.service";
import { EstruturasComponent } from "../../estruturas/estruturas.component";
import { localidadesRoute } from "../../estruturas/localidades/shared/data.service";
import { localidadesRoutes} from "../../estruturas/localidades/localidades-routing.module";
import { LocalidadesComponent } from "../../estruturas/localidades/localidades.component";
import { orgaosRoute } from "../../estruturas/orgaos/shared/data.service";
import { orgaosRoutes} from "../../estruturas/orgaos/orgaos-routing.module";
import { OrgaosComponent } from "../../estruturas/orgaos/orgaos.component";
import { areasRoute } from "../../estruturas/areas/shared/data.service";
import { areasRoutes } from "../../estruturas/areas/areas-routing.module";
import { AreasComponent } from "../../estruturas/areas/areas.component";
import { divisoesRoute} from "../../estruturas/divisoes/shared/data.service";
import { divisoesRoutes} from "../../estruturas/divisoes/divisoes-routing.module";
import { DivisoesComponent } from "../../estruturas/divisoes/divisoes.component";
import { setoresRoute } from "../../estruturas/setores/shared/data.service";
import { setoresRoutes } from "../../estruturas/setores/setores-routing.module";
import { SetoresComponent } from "../../estruturas/setores/setores.component";
import { bensRoute } from "../../bens/shared/data.service";
import { BensComponent } from "../../bens/bens.component";
import { marcasRoute } from "../../bens/marcas/shared/data.service";
import { MarcasComponent } from "../../bens/marcas/marcas.component";
import { marcasRoutes } from "../../bens/marcas/marcas-routing.module";
import { categoriasRoute } from "../../bens/categorias/shared/data.service";
import { CategoriasComponent } from "../../bens/categorias/categorias.component";
import { categoriasRoutes } from "../../bens/categorias/categorias-routing.module";
import { bemTiposRoute } from "../../bens/bem-tipos/shared/data.service";
import { BemTiposComponent } from "../../bens/bem-tipos/bem-tipos.component";
import { bemTiposRoutes } from "../../bens/bem-tipos/bem-tipos-routing.module";
import { modelosRoute } from "../../bens/modelos/shared/data.service";
import { ModelosComponent } from "../../bens/modelos/modelos.component";
import { modelosRoutes } from "../../bens/modelos/modelos-routing.module";
import { frotasRoute } from "../../bens/frotas/shared/data.service";
import { FrotasComponent } from "../../bens/frotas/frotas.component";
import { frotasRoutes } from "../../bens/frotas/frotas-routing.module";
import { viagensRoute } from "../../viagens/shared/data.service";
import { ViagensComponent } from "../../viagens/viagens.component";
import { abastecimentosRoute } from "../../abastecimentos/shared/data.service";
import { manutencoesRoute } from "../../manutencoes/shared/data.service";
import { ManutencoesComponent } from "../../manutencoes/manutencoes.component";
import { almoxarifadoRoute } from "../../almoxarifado/shared/data.service";
import { AlmoxarifadoComponent} from "../../almoxarifado/almoxarifado.component";
import { medidasRouter } from "../../almoxarifado/medidas/shared/data.service";
import { MedidasComponent } from "../../almoxarifado/medidas/medidas.component";
import { medidasRoutes } from "../../almoxarifado/medidas/medidas.routing";
import { contasRoute } from "../../contas/shared/data.service";
import { ContasComponent } from "../../contas/contas.component";
import { contasContabeisRouter } from "../../contas/conta-contabil/shared/data.service";
import { ContaContabilComponent } from "../../contas/conta-contabil/conta-contabil.component";
import { contaContabilRoutes } from "../../contas/conta-contabil/conta-contabil.routing";
import { gruposMateriaisRouter } from "../../almoxarifado/grupos-materiais/shared/data.service";
import { GruposMateriaisComponent } from "../../almoxarifado/grupos-materiais/grupos-materiais.component";
import { gruposMateriaisRoutes } from "../../almoxarifado/grupos-materiais/grupos-materiais.routing";
import { MateriaisComponent } from "../../almoxarifado/materiais/materiais.component";
import { materiaisRouter } from "../../almoxarifado/materiais/material/shared/data.service";
import { materiaisRoutes } from "../../almoxarifado/materiais/materiais.routing";
import { despachosRoute } from "../../despachos/shared/data.service";
import { DespachosComponent } from "../../despachos/despachos.component";
import { AbastecimentosComponent} from "../../abastecimentos/abastecimentos.component";
import { abastecimentosRoutes} from "../../abastecimentos/abastecimentos-routing.module";
import { viagensRoutes} from "../../viagens/viagens-routing.module";
import { usuariosRoutes} from "../../recursos-humanos/usuarios/usuarios-routing.module";
import { usuariosRoute} from "../../recursos-humanos/usuarios/shared/data.service";
import { UsuariosComponent} from "../../recursos-humanos/usuarios/usuarios.component";
import {manutencoesRoutes} from "../../manutencoes/manutencoes-routing.module";
import {despachosRoutes} from "../../despachos/despachos-routing.module";
import {rastreamentosRoute} from "../../rastreamentos/shared/data.service";
import {RastreamentosComponent} from "../../rastreamentos/rastreamentos.component";
import {rastreamentosRoutes} from "../../rastreamentos/rastreamentos-routing.module";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class GestaoRoutingModule {}

export const gestaoRoutes: any[] = [
    {
        path: '',
        component: HomeComponent
    },{
        path: recursosHumanosRoute,
        component: RecursosHumanosComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: '/' + pessoasRoute,
                pathMatch: 'full'
            },{
                path: pessoasRoute,
                component: PessoasComponent,
                canActivate: [AuthGuardService],
                children: pessoasRoutes
            },{
                path: motoristasRoute,
                component: MotoristasComponent,
                canActivate: [AuthGuardService],
                children: motoristasRoutes
            },{
                path: usuariosRoute,
                component: UsuariosComponent,
                canActivate: [AuthGuardService],
                children: usuariosRoutes
            }
        ]
    },{
        path: estruturasRoute,
        component: EstruturasComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: '/' + localidadesRoute,
                pathMatch: 'full'
            },{
                path: localidadesRoute,
                component: LocalidadesComponent,
                canActivate: [AuthGuardService],
                children: localidadesRoutes
            },{
                path: orgaosRoute,
                component: OrgaosComponent,
                canActivate: [AuthGuardService],
                children: orgaosRoutes
            },{
                path: areasRoute,
                component: AreasComponent,
                canActivate: [AuthGuardService],
                children: areasRoutes
            },{
                path: divisoesRoute,
                component: DivisoesComponent,
                canActivate: [AuthGuardService],
                children: divisoesRoutes
            },{
                path: setoresRoute,
                component: SetoresComponent,
                canActivate: [AuthGuardService],
                children: setoresRoutes
            }
        ]
    },{
        path: bensRoute,
        component: BensComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: '/' + marcasRoute,
                pathMatch: 'full'
            },{
                path: marcasRoute,
                component: MarcasComponent,
                canActivate: [AuthGuardService],
                children: marcasRoutes
            },{
                path: categoriasRoute,
                component: CategoriasComponent,
                canActivate: [AuthGuardService],
                children: categoriasRoutes
            },{
                path: bemTiposRoute,
                component: BemTiposComponent,
                canActivate: [AuthGuardService],
                children: bemTiposRoutes
            },{
                path: modelosRoute,
                component: ModelosComponent,
                canActivate: [AuthGuardService],
                children: modelosRoutes
            },{
                path: frotasRoute,
                component: FrotasComponent,
                canActivate: [AuthGuardService],
                children: frotasRoutes
            },
        ]
    },{
        path: viagensRoute,
        component: ViagensComponent,
        canActivateChild: [AuthGuardService],
        children: viagensRoutes
    },{
        path: abastecimentosRoute,
        component: AbastecimentosComponent,
        canActivateChild: [AuthGuardService],
        children: abastecimentosRoutes
    },{
        path: manutencoesRoute,
        component: ManutencoesComponent,
        canActivateChild: [AuthGuardService],
        children: manutencoesRoutes
    },{
        path: almoxarifadoRoute,
        component: AlmoxarifadoComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: '/' + medidasRouter,
                pathMatch: 'full'
            },{
                path: medidasRouter,
                component: MedidasComponent,
                canActivate: [AuthGuardService],
                children: medidasRoutes
            },{
                path: gruposMateriaisRouter,
                component: GruposMateriaisComponent,
                canActivate: [AuthGuardService],
                children: gruposMateriaisRoutes
            },{
                path: materiaisRouter,
                component: MateriaisComponent,
                canActivate: [AuthGuardService],
                children: materiaisRoutes
            }
        ]
    },{
        path: contasRoute,
        component: ContasComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: '',
                redirectTo: '/' + contasContabeisRouter,
                pathMatch: 'full'
            },{
                path: contasContabeisRouter,
                component: ContaContabilComponent,
                canActivate: [AuthGuardService],
                children: contaContabilRoutes
            }
        ]
    },{
        path: despachosRoute,
        component: DespachosComponent,
        canActivateChild: [AuthGuardService],
        children: despachosRoutes
    },{
        path: rastreamentosRoute,
        component: RastreamentosComponent,
        canActivateChild: [AuthGuardService],
        children: rastreamentosRoutes
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/gestao/gestao-routing.module.ts
 **/